/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import DateUtil from '../utilities/DateUtil';

class NoteModel {
  constructor(data) {
    this.data = _.assign({
      flagged: false,
      updated_at: DateUtil.getNowTimestamp(),
      created_at: DateUtil.getNowTimestamp(),
    }, data);

    this.categoryData = {};
  }

  identifier() {
    return this.data.id;
  }

  isNew() {
    return !this.data.id;
  }

  isNote() {
    return true;
  }

  isFile() {
    return false;
  }

  isFlagged() {
    return this.data.flagged;
  }

  getDate() {
    return _.get(this, 'data.updated_at', '');
  }

  getDatePrecision() {
    return 'P1D';
  }

  hasCategory() {
    return _.get(this, 'data.category_id', null) !== null;
  }

  getCategoryId() {
    return _.get(this, 'data.category_id', null);
  }

  getCategoryMessageKey() {
    return _.get(this, 'categoryData.key', '');
  }

  setCategoryId(categoryId) {
    this.data.category_id = categoryId;
  }

  setCategory(categoryData = {}) {
    this.categoryData = categoryData;
    this.data.category_id = categoryData.id;
  }

  setContent(text) {
    this.data.content = text;
  }

  setFlagged(value) {
    this.data.flagged = value;
  }

  toggleFlagged() {
    this.data.flagged = !this.data.flagged;
  }

  getContent() {
    return _.get(this, 'data.content', '');
  }

  getTruncatedText() {
    const trimmedContent = _.trimStart(this.getContent());
    const newLineIndex = trimmedContent.indexOf('\n');
    return newLineIndex === -1 ? trimmedContent : trimmedContent.substring(0, newLineIndex);
  }

  getSummaryText() {
    const linesOfText = _.compact(this.getContent().split('\n'));
    return linesOfText.length > 1 ? _.trimStart(linesOfText[1]) : '';
  }

  getUpdatedDate() {
    return this.data.updated_at;
  }

  isDifferentFrom(otherNoteData) {
    return this.getContent() !== _.get(otherNoteData, 'content', '');
  }
}

export default NoteModel;
